import { useTranslation } from "react-i18next";
import {
  CloseOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  InputNumber,
  message,
  Radio,
  RadioChangeEvent,
  Row,
  Space,
  Typography,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routesConfig } from "../../../config/routes";
import {
  createReviewCourse,
  getQuestionBank,
} from "../../../service/course-construct";
import FormItemDropdown from "../../form-dropdown/FormItemDropdown";
import FormInput from "../../form-input/FormInput";
import CommonModal from "../../modal/common";
import "./index.scss";

var indexDB = require("idbcache").default;

type Props = {
  open: boolean;
  isScheduleByTeacher?: boolean;
  onClose: () => void;
  id: string | undefined | number;
  sequenceId: number;
  parentName: string | undefined;
};

export default function AddLessionDrawer(props: Props) {
  const { t } = useTranslation();
  const { isScheduleByTeacher } = props;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [value, setValue] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [openCorfirmModal, setOpenCorfirmModal] = useState<boolean>(false);
  const [listQuestionBank, setListQuestionBank] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [dataSearch, setDataSearch] = useState<any>({
    page: 1,
    size: 20,
    keyword: "",
    types: ["unit_quiz"],
    status: [true],
  });
  const validation = {
    title: {
      required: true,
      message: t("Vui lòng nhập tiêu đề.", "Vui lòng nhập tiêu đề."),
    },
  };

  const onChange = (e: RadioChangeEvent) => {
    const type = e.target.value;
    setValue(type);
    let iconType = 1;
    if (type === 1) iconType = 1;
    else if (type === 2) iconType = 2;
    else if (type === 3) iconType = 3;

    form.setFieldsValue({ icon: iconType });
  };

  const renderIcon = () => {
    switch (value) {
      case 1:
        return <FileTextOutlined style={{ fontSize: "24px" }} />;
      case 2:
        return <QuestionCircleOutlined style={{ fontSize: "24px" }} />;
      case 3:
        return <SolutionOutlined style={{ fontSize: "24px" }} />;
    }
  };

  // 1 = 10
  // 2 = 20
  // 1 + 2 = 9999
  const listAssessments = [
    {
      label: t("Trực tuyến", "Trực tuyến"),
      value: 1,
      description: `Người học tham gia đánh giá trên nền tảng ${
        process.env.REACT_APP_PROJECT_NAME || ""
      }`,
    },
    {
      label: t("Trực tiếp", "Trực tiếp"),
      value: 2,
      description: t("Người học tham gia đánh giá trực tiếp tại Cơ sở đào tạo", "Người học tham gia đánh giá trực tiếp tại Cơ sở đào tạo"),
    },
  ];

  const optionTime = [
    {
      id: 10,
      name: t("Phút", "Phút"),
    },
    {
      id: 20,
      name: t("Giờ", "Giờ"),
    },
  ];

  const gotoAddLessonPage = () => {
    form.submit();
  };

  // Get list evaluation form
  const listVideo = listQuestionBank.map((item: any) => ({
    code: item.code,
    label: item.code,
  }));

  const getEvaluationForm = async (data: any) => {
    try {
      await getQuestionBank(data).then((res) => {
        setLoading(false);
        if (res.status === 200 && res.data.data) {
          setListQuestionBank(res.data.data.content);
          setTotalPages(res.data.data.totalPages);
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Load more videoTemplate
  const handlePopupScroll = (e: any) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // Check scroll to end to increase page
    if (scrollTop + clientHeight >= scrollHeight && !loadingMore) {
      setLoadingMore(true);

      if (totalPages > dataSearch.page) {
        setDataSearch((prevState: any) => ({
          ...prevState,
          page: prevState.page + 1,
        }));

        getQuestionBank({
          ...dataSearch,
          page: dataSearch.page + 1,
        }).then((res: any) => {
          if (
            res.status === 200 &&
            res.data.data &&
            res.data.data.content.length > 0
          ) {
            // Add new data
            setListQuestionBank((prevList: any) => [
              ...prevList,
              ...res.data.data.content,
            ]);
          }

          setLoadingMore(false);
        });
      }
    }
  };

  // useEffect
  useEffect(() => {
    if (props.open) {
      setLoading(true);
      getEvaluationForm(dataSearch);
    } else {
      setDataSearch({
        page: 1,
        size: 20,
        keyword: "",
        types: ["unit_quiz"],
        status: [true],
      });
      setLoadingMore(false);
    }
  }, [props.open]);

  useEffect(() => {
    if (props.open) {
      form.setFieldsValue({
        assessments: isScheduleByTeacher ? 1 : 1,
      });
    }
  }, [props.open, isScheduleByTeacher]);

  return (
    <Form.Provider
      onFormFinish={async (name, { values, forms }) => {
        if (name === "form-create-review-course") {
          const data = {
            title: values.title,
            description: values.description,
            courseSequenceId: props.sequenceId,
            iconType: values.icon,
            reviewType: values.typeStatus,
            formOfReview: values.assessments,
            expectedTime: values.expectedTime,
            expectedTimeType: values.expectedTimeType,
            fromUnitBankCode: values.videoTemplate,
          };

          await createReviewCourse(data).then((res) => {
            if (res.status === 200) {
              message.success(t("Tạo đánh giá thành công", "Tạo đánh giá thành công"));
              setOpenCorfirmModal(false);
              setTimeout(() => {
                form.resetFields();
                indexDB.set(
                  "current-course",
                  JSON.stringify({
                    name: data.title,
                    parent: props.parentName,
                    tabCurrent: "2",
                  }),
                  1440
                );

                if (values.assessments !== 1) {
                  navigate(
                    `${routesConfig.addTestSchedule}?unitId=${res.data.body.message}&blockId=${res.data.body.blockId}`,
                    { state: { courseId: res.data.body.message ?? "" } }
                  );
                } else {
                  navigate(
                    `${routesConfig.addLesson}?unitId=${res.data.body.message}&blockId=${res.data.body.blockId}`,
                    { state: { unitId: res.data.body.message ?? "" } }
                  );
                }
              }, 1000);
            }
          });
        }
      }}
    >
      <Drawer
        title={t("Thêm đánh giá", "Thêm đánh giá")}
        placement={"right"}
        className="add-lession-drawer"
        size={"large"}
        onClose={props.onClose}
        open={props.open}
      >
        <>
          {loading ? (
            <div className="loading-content">
              <LoadingOutlined />
            </div>
          ) : (
            <Form
              layout={"vertical"}
              form={form}
              name="form-create-review-course"
              initialValues={{
                typeStatus: 1,
                assessments: 1,
                expectedTime: 0,
                expectedTimeType: 10,
              }}
            >
              <Row gutter={[24, 12]}>
                <Typography.Title level={5}>{t("Thông tin chung", "Thông tin chung")}</Typography.Title>

                <Col span={24}>
                  <Form.Item
                    name="title"
                    rules={[validation.title]}
                    label={t("Tiêu đề", "Tiêu đề")}
                  >
                    <FormInput placeholder={t("Tiêu đề", "Tiêu đề")} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="description" label={t("Mô tả", "Mô tả")}>
                    <TextArea showCount maxLength={512} placeholder={t("Mô tả", "Mô tả")} />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item name="icon">
                    <div className="flex align-center gap-8">
                      <span>Icon</span>
                      {renderIcon()}
                    </div>
                  </Form.Item>
                </Col>

                <Col span={18}>
                  <Form.Item
                    name="videoTemplate"
                    label={t("Chọn mẫu", "Chọn mẫu")}
                    className="last-form-item"
                  >
                    <FormItemDropdown
                      options={listVideo}
                      allowClear={true}
                      placeholder={t("Chọn mẫu", "Chọn mẫu")}
                      onPopupScroll={handlePopupScroll}
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item name="typeStatus" label={t("Loại đánh giá", "Loại đánh giá")}>
                    <Radio.Group onChange={onChange} value={value}>
                      <Radio value={1}>{t("Bài tập", "Bài tập")}</Radio>
                      <Radio value={2}>{t("Bài kiểm tra", "Bài kiểm tra")}</Radio>
                      <Radio value={3}>{t("Bài thi", "Bài thi")}</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="assessments"
                    label={t("Hình thức đánh giá", "Hình thức đánh giá")}
                    style={{ display: isScheduleByTeacher ? "block" : "none" }}
                  >
                    <Radio.Group>
                      {listAssessments.map((op) => (
                        <Radio key={op.value} value={op.value}>
                          {op.label}
                        </Radio>
                      ))}
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item name="expectedTime" label={t("Nỗ lực mong chờ", "Nỗ lực mong chờ")}>
                    <InputNumber style={{ width: "100%" }} min={1} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="expectedTimeType" label=" ">
                    <FormItemDropdown options={optionTime} />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="mt-3 float-right">
                <Space>
                  <Button onClick={props.onClose} className="btn btn-outlined">
                    <CloseOutlined />
                    <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
                  </Button>
                  <Button
                    className="btn btn-primary"
                    onClick={() => setOpenCorfirmModal(true)}
                  >
                    <SaveOutlined />
                    <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
                  </Button>
                </Space>
              </Row>

              <CommonModal
                open={openCorfirmModal}
                title={t("Thông báo xác nhận lưu học liệu", "Thông báo xác nhận lưu học liệu")}
                // desc={t("Vui lòng xác nhận lưu học liệu trong khoá học", "Vui lòng xác nhận lưu học liệu trong khoá học")}
                desc={
                  <>
                    <p>
                      {t("Xin vui lòng xác nhận việc lưu học liệu trong khoá học", "Xin vui lòng xác nhận việc lưu học liệu trong khoá học")}
                    </p>
                    <div>
                      {t("Đảm bảo rằng tất cả các", "Đảm bảo rằng tất cả các")}{" "}
                      <span className="text-browse">
                        {t("thông tin liên quan đã được kiểm tra và cập nhật đầy đủ", "thông tin liên quan đã được kiểm tra và cập nhật đầy đủ")}{" "}
                      </span>
                      {t("trước khi lưu khoá học", "trước khi lưu khoá học")}
                    </div>
                  </>
                }
                closeIcon={true}
                okText={t("Xác nhận", "Xác nhận")}
                cancelText={t("Huỷ", "Huỷ")}
                icon={
                  <InfoCircleOutlined
                    style={{ color: "#FFC53D", marginRight: "10px" }}
                  />
                }
                confirm={gotoAddLessonPage}
                closeModal={() => setOpenCorfirmModal(false)}
              />
            </Form>
          )}
        </>
      </Drawer>
    </Form.Provider>
  );
}
